<script>
    import { language } from './stores';
    import { parseDate, differentDays } from './date.js';
    import Event from './Event.svelte';
    import { DateTime } from 'luxon';

    const now = DateTime.now();

    export let data;
    let processedCalendar;
    $: processedCalendar = processCalendar(data);

    function processCalendar(data) {
        let events = data.events.map((event) => {
            return {
                type: "event",
                starttime: parseDate(event.starttime, event.starttime_timezone),
                endtime: parseDate(event.endtime, event.endtime_timezone),
                name: event.name,
                description: event.description,
                location: event.location
            }
        }).sort((a, b) => (a.starttime > b.starttime) ? 1 : -1);

        // go through the list of events, inserting our "pseudo-events" representing new days etc
        for (let i = events.length-1; i >= 0; i--) {
            if (i <= 0 || differentDays(events[i].starttime, events[i-1].starttime)) {
                events.splice(i, 0, {
                    type: "newday",
                    starttime: events[i].starttime.startOf("day"),
                    endtime: events[i].starttime.startOf("day")
                });
            }
        }
        for (let i = 0; i <= events.length; i++) {
            if ((i<=0 || events[i-1].endtime < now) && (i>=events.length || events[i].starttime > now)) {
                events.splice(i, 0, {
                    type: "now"
                });
            }
        }

        return events;
    }
</script>

<style>
.eventslist {
    display: flex;
    flex-direction: column;
}

.newday:not(:first-child) {
    margin-top: 0.5em;
}
.newday {
    font-size: 1.3em;
    font-weight: 500;
}

.now {
    color: red;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 0.8em;
    margin: 0.5em 0;
}

.nowline {
    flex-grow: 1;
    height: 0;
    margin-left: 0.3em;
    border-bottom: 1px solid red;
}
</style>

<div class="eventslist">
{#each processedCalendar as event, i}
{#if event.type == "newday"}
<div class="newday">{event.starttime.setLocale($language).toLocaleString({ month: 'short', day: 'numeric', weekday: 'long' }).replace(/^\w/, c => c.toUpperCase())}</div>
{:else if event.type == "now"}
<div class="now">{{en:"we are here",sv:"vi är här"}[$language]}<div class="nowline"></div></div>
{:else if event.type == "event"}
<div class="event"><Event data={event} /></div>
{/if}
{/each}
</div>